'use client';

import { useState, useEffect, Suspense, lazy } from 'react';
import { LocationHydration } from 'stores/LocationStore';

import LocationButton from '../LocationButton/LocationButton';
import * as styles from './NewHeaderContext.css';
import SearchSkeleton from 'components/AlgoliaSearch/SearchSkeleton';
import { useIsPartnerPage } from 'hooks/useIsPartnerPage';
import { useIsClubeIfoodDiscountPage } from 'hooks/useIsClubeIfoodDiscountPage';

const AlgoliaSearch = lazy(
  () => import('components/AlgoliaSearch/AlgoliaSearch')
);

function NewHeaderContext({
  locationHydration,
  isNavbarCollapsed = false,
  variant,
  isDark = false,
  hasMossColor = false
}: {
  locationHydration: LocationHydration;
  isNavbarCollapsed?: boolean;
  variant?: 'default' | 'primary' | 'dark';
  isDark?: boolean;
  hasMossColor?: boolean;
}) {
  const [isMounted, setIsMounted] = useState(false);
  const { isPartnerPage } = useIsPartnerPage();
  const isClubeIfoodDiscountPage = useIsClubeIfoodDiscountPage();

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <div
      className={`${styles.container} ${
        isNavbarCollapsed && styles.colapsedContainer
      }`}
    >
      {!isPartnerPage && (
        <>
          {!isMounted ? (
            <SearchSkeleton
              isNavbarCollapsed={isNavbarCollapsed}
              isDark={isDark}
            />
          ) : (
            <Suspense
              fallback={
                <SearchSkeleton
                  isNavbarCollapsed={isNavbarCollapsed}
                  isDark={isDark}
                />
              }
            >
              <AlgoliaSearch
                isNavbarCollapsed={isNavbarCollapsed}
                isDark={isDark}
                hasMossColor={hasMossColor}
              />
            </Suspense>
          )}
        </>
      )}

      <div
        className={`${styles.filtersContainer} ${
          isNavbarCollapsed && styles.filtersContainerCollapsed
        }`}
      >
        <LocationButton
          selectedLocation={locationHydration.selectedLocation}
          variant={variant}
          isNavbarCollapsed={isNavbarCollapsed}
          useSlugParam={isClubeIfoodDiscountPage}
        />
      </div>
    </div>
  );
}

export default NewHeaderContext;
